import styled from 'styled-components';

import BaseRadio from '@r1-frontend/ui-react/components/controls/baseRadio';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Item = styled.div<{ isChecked: boolean }>`
    height: 76px;
    padding: 16px;

    border-width: 2px;
    border-style: solid;
    border-color: ${({ isChecked }) => isChecked ? COLORS.Outline_Dark : 'transparent'};
    border-radius: 26px;
    background-color: ${COLORS.BgSurface};
    transition: all .25s ease;
`;

export const ItemRadio = styled(BaseRadio)`
    label {
        font-size: 14px;
        line-height: 20px;

        white-space: break-spaces;
    }
    
    input[type='radio'] {
        align-self: center;
    }
`;

export const TextWrapper = styled.div`
    span {
        ${FONTS.XS}
    }
`;
